var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var Search20 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '20px' : _c, _d = _a.width, width = _d === void 0 ? '20px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 20 20", style: svgStyle },
            React.createElement("desc", null, "Created with Sketch."),
            React.createElement("g", { id: "Search_20_svg__Icons/Search/20", stroke: "none", strokeWidth: 1, fillRule: "evenodd" },
                React.createElement("path", { d: "M8.5,2 C12.0898509,2 15,4.91014913 15,8.5 C15,10.1148687 14.4111063,11.592194 13.4363556,12.7289391 L18.0134785,17.3063718 L17.3063718,18.0134785 L12.7289391,13.4363556 C11.592194,14.4111063 10.1148687,15 8.5,15 C4.91014913,15 2,12.0898509 2,8.5 C2,4.91014913 4.91014913,2 8.5,2 Z M8.5,3 C5.46243388,3 3,5.46243388 3,8.5 C3,11.5375661 5.46243388,14 8.5,14 C11.5375661,14 14,11.5375661 14,8.5 C14,5.46243388 11.5375661,3 8.5,3 Z", id: "Search_20_svg__Combined-Shape", fillRule: "nonzero" })))));
};
Search20.displayName = 'Search20';
export default Search20;
//# sourceMappingURL=search-20.js.map